/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// jQuery読み込み前提
$(function() {
  if ($('.js-toggleAccordion').length > 0) {
    $('.js-toggleAccordion').on('click', function () {
      $(this).parent().toggleClass('is-open');
      $(this).next('.ArticleItem__Excerpt').slideToggle();
    });
  }

  $('.js-giftselect input').on('change', function () {
    var value = $(this).val();
    if (value == "する") {
      $('#form-present').slideDown();
      // $('select[name="properties[梱包]"]').val("");
    } else {
      $('#form-present').slideUp();
      $('select[name="properties[梱包]"]').val("");
    }
  });


  // instagram
  $.ajax({
    type: 'GET',
    url: 'https://graph.facebook.com/v12.0/17841400525175813?fields=name%2Cmedia.limit(6)%7Bcaption%2Clike_count%2Cmedia_url%2Cpermalink%2Cthumbnail_url%7D&access_token=EAAExxEtmGHEBAO8sZATT2foLEsEtwMTxvNjfZBdFm00cMIFesMbbRUhyqHBqb00lrkFPLtIOaKVD0LZCtWPEZCIwBYnJtW17pQ4JVh5wGBGuakSSjjfnR8ZC3uyYMWZA19epUZAKASLbeffZABHflKVFOLLA0DJOmzZAkTt1kpsNGoMD6hgPcvUtJ',
    dataType: 'json',
    success: function (json) {
      var ig = json.media.data;
      var html = "";
      for (var i = 0; i < ig.length; i++) {
        var link = ig[i].permalink;
        var image;
        if (!ig[i].thumbnail_url) {
          // 動画の場合はこちら
          image = ig[i].media_url;
        } else {
          // 写真の場合はこちら
          image = ig[i].thumbnail_url;
        }
        html += '<li><a href="' + link + '" target="_blank"><img src="' + image + '"></a></li>'
      }
      $("#instafeed").append(html);
    }
  });


  // 無効なフィールドがある場合にフォーム送信を無効にするスターターJavaScriptの例
  (function () {
    'use strict';

    window.addEventListener('load', function () {
      // カスタムブートストラップ検証スタイルを適用するすべてのフォームを取得
      var forms = document.getElementsByClassName('needs-validation');
      // ループして帰順を防ぐ
      var validation = Array.prototype.filter.call(forms, function (form) {
        // submitボタンを押したら以下を実行
        form.addEventListener('submit', function (event) {
          console.log('submit!!!')
          if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            form.classList.add('has-invalid'); //エラーがあったらクラス追加
          }
          form.classList.add('was-validated');
        }, false);
      });
    }, false);
  })();

  if (location.href.match("customer_posted=true") != null) {
    var target = $('.footer-newsletter').offset();
    $('html, body').animate({
      scrollTop: target.top
    }, 500);
  }
}); // $(function() の閉じ括弧